import React, { useState, useEffect } from 'react'

import {
  Form,
  Input,
  Tag,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Space,
  Button,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Descriptions,
  Breadcrumb,
  Typography,
} from '@pankod/refine-antd'
import { Upload, message } from 'antd'
import { uploadQuestionMedia } from 'helpers/question/media'
import { UploadOutlined } from '@ant-design/icons'
import { setInitialFilters, useGetIdentity, useMany, useTable, useCreateMany } from '@pankod/refine-core'
import ReactMarkdown from 'react-markdown'
import ReactMde from 'react-mde'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import { CrudFilters, CrudFilter } from '@pankod/refine-core'

import 'react-mde/lib/styles/css/react-mde-all.css'
import {
  IGrade,
 
  IQuestionType,
  
} from 'interfaces'
import { type } from 'os'
import { nhost } from 'utility'
import { forEachChild } from 'typescript'
import { resolve } from 'path'
import { getLastCreatedDraftQuestion } from 'gql/query'
import { createLogForReview, createLogOpen, getLastCreatedQuestion } from 'gql/mutations'
import { ReactMdeToolbarCommands } from 'helpers/markdownConfig'
import sendEmail from 'sendmail'
import { useUserContext } from 'context/user'

type CreateQuestionProps = {
  modalProps: ModalProps
  formProps: FormProps
  data: any
  gradeList?: { grade_ids: string[] }
}

const { TextArea } = Input

export const CreateDraftQuestion: React.FC<CreateQuestionProps> = ({ modalProps, formProps, data, gradeList }) => {
  console.log('zzzzzzzzzzzz', data)
  const { data: user } = useGetIdentity()
  const {qapproverList,qreviewerList}=useUserContext()
  const { mutateAsync: createNotification } = useCreateMany()
  const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>('write')
  const [questionType, setQuestionType] = useState('MCQ')
  const [optionType, setOptionType] = useState('Text')
  const [selectedOptionTab, setSelectedOptionTab] = useState<string[]>([])
  const { Option } = Select
  const [taxonomyfilter, setTaxonomyFilter] = useState<any[]>([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [selectedItems, setSelectedItems] = useState<string>('')
  const [approverList, setApproverList] = useState<any[]>([])
  const [reviewerList, setReviewerList] = useState<any[]>([])

  const option_tags = ['Right Answer', 'Most Wrong', 'Close to Correct']
  const filteredOptions = option_tags?.filter(o => selectedItems !== o)

  const { userRole } = useUserContext()

  {
    /*Variant Selection ****************/
  }
  const [variantListIds, setVariantListIds] = useState<string[]>([])
  const [variantList, setVariantList] = useState<object[]>([])

  //file upload start ------------------------------
  const [fileList, setFileList] = useState<any>({})
  const [uploading, setUploading] = useState(false)

  /** Returns null when a file is rejected, so onFinish can abort instead of saving a half-uploaded question. */
  const handleImageUpload = async (option_details: any) => {
    setUploading(true)
    let metadatas: any = {}
    try {
      for (let key = 0; key < option_details.length; key++) {
        const file = option_details[key]?.option_image_id?.file
        if (!file) continue

        const result = await uploadQuestionMedia(file)
        if (!result.ok) {
          message.error(`Option ${key + 1}: ${result.message}`)
          return null
        }

        metadatas[key] = { id: result.fileId, name: result.name }
      }
    } finally {
      setUploading(false)
    }
    return metadatas
  }
  //file upload end ---------------------------

  //list of grades when creating question from edit papers
  const getListOfGrades = gradeList?.grade_ids ?? []

  const { selectProps: gradeSelectProps, queryResult: gradeQueryResult } = useSelect<IGrade>({
    defaultValue: getListOfGrades,
    resource: 'grades',
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      {
        field: 'id',
        operator: 'in',
        value: getListOfGrades,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  // ------------------- --------------------del autpfill grade

  const { selectProps: questionTypeSelectProps } = useSelect<IQuestionType>({
    resource: 'question_types',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
  })

 

 

  const save = async function* (data: any) {
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')

    const { fileMetadata } = await nhost.storage.upload({ file })
    const publicUrl = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield publicUrl
    await wait(2000)
    return true
  }

  const saveOptions = async function* (data: any) {
    // console.log('first-----', key)
    const wait = function (time: any) {
      return new Promise<void>((a, r) => {
        setTimeout(() => a(), time)
      })
    }
    var arrayBufferView = new Uint8Array(data)
    var blob = new Blob([arrayBufferView], { type: 'image/jpeg' })
    var file = new File([blob], 'image.jpg')
    const { fileMetadata } = await nhost.storage.upload({ file })
    console.log({ fileMetadata })
    let url = nhost.storage.getPublicUrl({ fileId: fileMetadata?.id || '' })

    await wait(2000)
    // yields the URL that should be inserted in the markdown

    yield url
    await wait(2000)
    return true
  }

  const handleOptionTabChange = (value: any, key: any) => {
    let arr: string[] = [...selectedOptionTab]
    if (value === 'preview') {
      arr.push(key)
    }
    if (value === 'write') {
      if (arr.includes(key)) {
        arr.splice(arr.indexOf(key), 1)
      }
    }
    console.log({ arr })
    setSelectedOptionTab(arr)
  }

  const handleOptionTags = (value: string) => {
    if (questionType === 'MCQ') {
      const field = formProps?.form?.getFieldValue('option_details')
      const found = field?.findIndex((element: any) => element?.option_flag === 'Right Answer')
      if (found === -1) {
        setSelectedItems('')
      } else {
        setSelectedItems('Right Answer')
      }
    }
  }

  const handleQuestionType = (value: any) => {
    setQuestionType(value)
  }
  const handleOptionType = (value: any) => {
    setOptionType(value)
  }

  useEffect(() => {
    ;(async function setReviewerandApprover() {
      if (modalProps?.visible) {
        const reviewerResult = qreviewerList?.map((user: any) => {
          return { label: user?.displayName, value: user?.id }
        })
        setReviewerList(reviewerResult)
        const approverResult =qapproverList?.map((user: any) => {
          return { label: user?.displayName, value: user?.id }
        })
        setApproverList(approverResult)
      }
    })()
  }, [modalProps?.visible])

  const onFinish = async (values: any) => {
    //image option transform
    let image_option_details: any = []
    if (values.option_type === 'Image') {
      const metadatas = await handleImageUpload(values.option_details)
      // A rejected file already surfaced its own message; stop rather than save partial options.
      if (!metadatas) return
      values.option_details.forEach((option: any, index: number) => {
        let newOption = { ...option }
        newOption.option_image_id = metadatas[index]?.id ?? option.option_image_id
        newOption.option_image_name = metadatas[index]?.name ?? option.option_image_name
        image_option_details.push(newOption)
      })
    }

    if (!uploading) {
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          status: 'Draft',
          grade_ids: [...getListOfGrades],
          option_type: values.option_type ?? 'Text',
          option_details: values.option_type === 'Image' ? image_option_details : values.option_details,
          question_type_id: data?.question_type_id,
          creator_id: user?.id,
          subject_id: data?.subject_id,
          theme_id: data?.theme_id,
          report_theme_id: data?.report_theme_id,
          sub_theme_id: data?.sub_theme_id,
          topic_id: data?.topic_id,
          paper_id: data?.paperId,
          centa_concept_id: values?.centa_concept_id,
          explanation_type_id: values?.explanation_type_id,
        })
      )
    }
  }

  useEffect(() => {
    if (data && data.question_type_id) {
      setQuestionType(data.question_type_id)
    }
  }, [data])

  return (
    <Modal {...modalProps} title="Create Question" style={{height:"100%",top:0}}>
      {JSON.stringify(data) !== '{}' ? (
        <>
          <Descriptions size="small" column={3}>
            {data?.subject?.name && <Descriptions.Item label="Subject">{data?.subject?.name}</Descriptions.Item>}
            {data?.subject?.name && <Descriptions.Item label="Report Theme (TN_Term_Month)">{data?.subject?.name}</Descriptions.Item>}
            {data?.theme?.name && <Descriptions.Item label="Theme (TN Chapter Name)">{data?.theme?.name}</Descriptions.Item>}
          </Descriptions>
          <Descriptions size="small" column={2}>
            {data?.sub_theme?.name && (
              <Descriptions.Item label="Sub-theme (CENTA Concept ID_CENTA Concept Name)">{data?.sub_theme?.name}</Descriptions.Item>
            )}
            {data?.topic?.name && <Descriptions.Item label="Topic">{data?.topic?.name}</Descriptions.Item>}
            {data?.question_type?.name && <Descriptions.Item label="Question Type">{data?.question_type?.name}</Descriptions.Item>}
          </Descriptions>
          <Divider style={{ margin: '4px 0' }} />
        </>
      ) : null}
      <Row gutter={[16, 0]}>
        <Col xs={24} lg={24}>
          <Divider orientation="left" orientationMargin="0" className="primary">
            Question Details
          </Divider>
        </Col>
      </Row>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          await onFinish(values)
          const draftQueResp: any = await getLastCreatedDraftQuestion({ _and: [{ created_by: { _eq: user?.id } }, { status: { _eq: 'Draft' } }] })
          const lastQueId = draftQueResp?.questions?.[0]?.id
          await createLogOpen(user?.id, undefined, lastQueId, data?.paperId)
          let notification_arr = []
          let mail_arr = []
          const reviewerData = reviewerList.filter(user => user?.user?.id === values?.reviewer_id)[0]
          const approverData = approverList.filter(user => user?.user?.id === values?.approver_id)[0]
          notification_arr.push(
            {
              description: 'A draft question has been assigned to you.',
              sender: user?.id,
              recepient: values?.reviewer_id,
              source_name: 'questions',
              title: 'New Task',
              recepient_user_role: 'qreviewer',
            },
            {
              description: 'A draft question has been assigned to you.',
              sender: user?.id,
              recepient: values?.approver_id,
              source_name: 'questions',
              title: 'New Task',
              recepient_user_role: 'qapprover',
            }
          )

          // mail_arr.push({
          //   subject: 'Question Created and assigned to you',
          //   to: [{ name: approverData?.user?.displayName, email: approverData?.user?.email }],
          //   htmlContent: `<html><body>Hi,<br/><h4> Question ${values?.name} is created by ${user?.displayName} and assigned to you. Review the question. For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          // },{
          //   subject: 'Question Created and assigned to you',
          //   to: [{ name: approverData?.user?.displayName, email: approverData?.user?.email }],
          //   htmlContent: `<html><body>Hi,<br/><h4> Question ${values?.name} is created by ${user?.displayName} and assigned to you. Question to approve will assign shortly.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          // })

          // await createNotification({ resource: 'notifications', values: notification_arr })
        }}
      >
        <Row gutter={[16, 0]}>
          {JSON.stringify(data) === '{}' || data?.id === '' || data?.id === null ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Question Type" name="question_type" initialValue={'MCQ'} rules={[{ required: true }]}>
                <Select onChange={handleQuestionType} {...questionTypeSelectProps} />
              </Form.Item>
            </Col>
          ) : null}
          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids">
              {/**rules={[{ required: true }]} **/}
              {getListOfGrades.length > 0 ? (
                gradeQueryResult?.data?.data?.map(({ id, name }) => <Typography.Text keyboard>{name}</Typography.Text>)
              ) : (
                <Select {...gradeSelectProps} mode="multiple" />
              )}
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Form.Item
              label="Question"
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <ReactMde
                selectedTab={selectedTab}
                onTabChange={setSelectedTab}
                generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                toolbarCommands={ReactMdeToolbarCommands}
                paste={{
                  saveImage: save,
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={24}>
            <Form.Item name={'question_insight'} rules={[{ required: false }]}>
              <TextArea rows={4} placeholder="Question Insight" disabled={userRole === 'qreviewer' || userRole === 'qapprover'} />
            </Form.Item>
          </Col>
          {questionType === 'ShortAnswer' && (
            <Col xs={24} lg={24}>
              <Form.Item label="Expected points in the answer" name="description">
                <Input />
              </Form.Item>
            </Col>
          )}
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              {questionType === 'ShortAnswer' && 'Rubric Details'}
              {questionType === 'MCQ' && 'Option Details'}
              {questionType === 'Match' && 'Label Details'}
              {questionType === 'Fill' && 'Answer Details'}
            </Divider>
          </Col>
          {/* {questionType === ('MCQ' || 'Match') && ( */}
          {/* {questionType === 'MCQ' && (
            <Col xs={24} lg={12}>
              <Form.Item label="Options Type" name="option_type" initialValue={'Text'}>
                <Select
                  onChange={handleOptionType}
                  options={[
                    { label: 'Text', value: 'Text' },
                    { label: 'Image', value: 'Image' },
                  ]}
                />
              </Form.Item>
            </Col>
          )} */}
        </Row>
        {questionType === 'MCQ' && (
          <Form.List name="option_details">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                    <Form.Item {...restField} name={[name, 'option_text']} rules={[{ required: true, message: 'Missing Option Value' }]}>
                      <ReactMde
                        selectedTab={selectedOptionTab?.includes('mcq_' + key) ? 'preview' : 'write'}
                        onTabChange={(value: any) => handleOptionTabChange(value, 'mcq_' + key)}
                        maxEditorHeight={85}
                        // onChange={value => handleValueChange(value, key)}
                        generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                        toolbarCommands={ReactMdeToolbarCommands}
                        paste={{
                          saveImage: saveOptions,
                        }}
                      />
                    </Form.Item>
                    <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                      <TextArea placeholder="Option Insight" rows={7} />
                    </Form.Item>
                    {/* <Form.Item {...restField} name={[name, 'option_flag']} rules={[{ required: true, message: 'Missing Option Flag' }]}>
                      <Select
                        options={[
                          { label: 'Right Answer', value: 'Right Answer' },
                          { label: 'Most Wrong', value: 'Most Wrong' },
                          {
                            label: 'Close to Correct',
                            value: 'Close to Correct',
                          },
                        ]}
                        placeholder="Option Flag"
                        style={{ width: 150 }}
                      />
                    </Form.Item> */}
                    <Form.Item {...restField} name={[name, 'option_flag']} rules={[{ required: true, message: 'Missing Option Flag' }]}>
                      <Select
                        placeholder="Option Flag"
                        style={{ width: 150 }}
                        // value={selectedItems}
                        onChange={handleOptionTags}
                        // onDeselect={handleDeselectOptionTags}
                        allowClear
                        options={filteredOptions.map(item => ({
                          value: item,
                          label: item,
                        }))}
                      />
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'Fill' && (
          <Form.List name="option_details">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  // <Space key={key} style={{ display: 'flex', marginBottom: 8, width: '100%' }} align="baseline">
                  <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                    <Col lg={15}>
                      <Form.Item {...restField} name={[name, 'right_answer']} rules={[{ required: true, message: 'Missing Option Answer' }]}>
                        <TextArea rows={4} placeholder="Right Answer" />
                      </Form.Item>
                    </Col>
                    <Col lg={7}>
                      <Form.Item {...restField} name={[name, 'option_insights']} rules={[{ required: false }]}>
                        <TextArea rows={4} placeholder="Option Insight" />
                      </Form.Item>
                    </Col>
                    <Col lg={2}>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Col>
                  </Row>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'Match' && (
          <Form.List name="option_details">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                    {optionType === 'Text' && (
                      <>
                        <Row gutter={[8, 16]} style={{ display: 'flex', alignItems: 'center' }}>
                          <Col lg={8}>
                            <Form.Item {...restField} name={[name, 'left_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                              <ReactMde
                                selectedTab={selectedOptionTab?.includes('match_left_' + key) ? 'preview' : 'write'}
                                onTabChange={(value: any) => handleOptionTabChange(value, 'match_left_' + key)}
                                maxEditorHeight={75}
                                //  onChange={value => handleValueChange(value, key)}
                                generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                                toolbarCommands={ReactMdeToolbarCommands}
                                paste={{
                                  saveImage: saveOptions,
                                }}
                              />
                              {/* <Input placeholder="Left Label" type="small" /> */}
                            </Form.Item>
                          </Col>
                          <Col lg={8}>
                            <Form.Item {...restField} name={[name, 'right_label_text']} rules={[{ required: true, message: 'Missing Section' }]}>
                              <ReactMde
                                selectedTab={selectedOptionTab?.includes('match_right_' + key) ? 'preview' : 'write'}
                                onTabChange={(value: any) => handleOptionTabChange(value, 'match_right_' + key)}
                                maxEditorHeight={75}
                                //  onChange={value => handleValueChange(value, key)}
                                generateMarkdownPreview={markdown => Promise.resolve(<ReactMarkdown>{markdown}</ReactMarkdown>)}
                                toolbarCommands={ReactMdeToolbarCommands}
                                paste={{
                                  saveImage: saveOptions,
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col lg={7}>
                            <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                              <TextArea rows={5} placeholder="Option Insight" />
                            </Form.Item>
                          </Col>

                          <Col lg={1}>
                            <MinusCircleOutlined onClick={() => remove(name)} />
                          </Col>
                        </Row>
                      </>
                    )}
                    {/* <Form.Item {...restField} name={[name, 'option_insight']} rules={[{ required: false }]}>
                      <Input placeholder="Option Insight" type="small" />
                    </Form.Item> */}

                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
                <Form.Item>
                  <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    Add Option
                  </Button>
                </Form.Item>
              </>
            )}
          </Form.List>
        )}
        {questionType === 'ShortAnswer' && (
          <Form.List
            initialValue={[
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
              {
                component_name: '',
                rating_1: '',
                rating_2: '',
                rating_3: '',
                rating_4: '',
                weightage: '',
              },
            ]}
            rules={[
              {
                validator: async (_, names) => {
                  if (names.length >= 8) {
                    return Promise.reject(new Error('Exceeded maximum rubric field. (Max is 7)'))
                  }
                },
              },
            ]}
            name="option_details"
          >
            {(fields, { add, remove }, { errors }) => {
              return (
                <>
                  {fields.map(({ key, name, ...restField }) => (
                    <Space key={key} style={{ display: 'flex', marginBottom: 8 }} align="baseline">
                      <Form.Item {...restField} name={[name, 'component_name']} rules={[{ required: true, message: 'Missing Section' }]}>
                        <Input placeholder="Component Name" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_1']} rules={[{ required: true, message: 'Missing Rating 1' }]}>
                        <Input placeholder="Rating 1" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_2']} rules={[{ required: true, message: 'Missing Rating 2' }]}>
                        <Input placeholder="Rating 2" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_3']} rules={[{ required: true, message: 'Missing Rating 3' }]}>
                        <Input placeholder="Rating 3" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'rating_4']} rules={[{ required: true, message: 'Missing Rating 4' }]}>
                        <Input placeholder="Rating 4" type="small" />
                      </Form.Item>
                      <Form.Item {...restField} name={[name, 'weightage']} rules={[{ required: true, message: 'Missing Weightage' }]}>
                        <Input placeholder="Weightage" type="small" style={{ maxWidth: 150 }} />
                      </Form.Item>
                      <MinusCircleOutlined onClick={() => remove(name)} />
                    </Space>
                  ))}
                  <Form.Item>
                    <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                      Add Option
                    </Button>
                  </Form.Item>
                  <Form.ErrorList errors={errors} />
                </>
              )
            }}
          </Form.List>
        )}
        <Row gutter={[16, 0]}>
          {/* <Col lg={6}>
            <Form.Item label="Choose the reviewer's name" name="reviewer_id" rules={[{ required: true }]}>
              <Select options={reviewerList}></Select>
            </Form.Item>
          </Col>
          <Col lg={6}>
            <Form.Item label="choose the approver's name" name="approver_id" rules={[{ required: true }]}>
              <Select options={approverList}></Select>
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col> */}

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Centa Concept" name="centa_concept_id" rules={[{ required: true }]}>
              <Select {...centaConceptProps} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Explanation Type" name="explanation_type_id" rules={[{ required: true }]}>
              <Select {...explanationTypeProps} />
            </Form.Item>
          </Col> */}
          <Form.Item name="created_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  )
}
